// @flow

import OpponentTeamComposition from 'components/rencontre/OpponentTeamComposition';
import TeamComposition from 'components/rencontre/TeamComposition';
import EmptyState from 'components/competitionsInternationales/CompetitionsinternationalesSingleMatchEmptyState';
import React, { Component } from 'react';

import type { RencontreType } from 'types/Rencontre';

export type StateProps = {
  rencontre: RencontreType
};

type Props = StateProps;

type State = {
  team: 'france' | 'other'
};

class CompetitionsInternationalesSingleMatchComposition extends Component<Props, State> {
  state = {
    team: 'france'
  };

  render() {
    const {
      rencontre: {
        joueurs,
        staffs,
        faits_de_jeu,
        meta: { afficher_composition, equipe_adverse, equipeNom }
      }
    } = this.props;

    let classes = 'container compet-itl--single-match--composition';
    if (!afficher_composition) {
      classes = `${classes} with-empty-state`;
    }

    return (
      <section className={classes}>
        {!afficher_composition ? (
          <EmptyState
            titleFirstPart="Composition"
            titleSecondPart="du match"
            description="La composition du match sera disponible très prochainement."
            backgroundImage="/img/empty-state-composition.png"
          />
        ) : (
          <>
            <TeamComposition joueurs={joueurs} staffs={staffs} faits={faits_de_jeu} isWomen={equipeNom.includes('Féminin')} />
            {equipe_adverse.trim() !== '' && <OpponentTeamComposition equipe={equipe_adverse} withoutDropdown />}
          </>
        )}
      </section>
    );
  }
}

export default CompetitionsInternationalesSingleMatchComposition;
